import React, { useMemo } from "react";

import { useIntl } from "react-intl";

import { convertLongLatToLatLngLiteral } from "@mapmycustomers/shared/util/geo/GeoService";

import MapTooltip from "@app/scene/map/components/MapTooltip";
import LocationGroup from "@app/types/map/LocationGroup";

interface Props {
  locationGroup: LocationGroup;
}

const UserTooltip: React.FC<Props> = ({ locationGroup }) => {
  const intl = useIntl();

  const position = useMemo(
    () => convertLongLatToLatLngLiteral(locationGroup.locations[0]?.geoPoint.coordinates),
    [locationGroup]
  );
  if (!position || locationGroup.locations.length < 2) {
    return null;
  }

  return (
    <MapTooltip
      position={position}
      showArrow={false}
      tooltip={intl.formatMessage(
        {
          id: "map.layer.userLocation.locationHistory.pin.tooltip",
          defaultMessage: "{count} recent events at this location",
          description: "Map - user location pane - user location history - pin tooltip",
        },
        { count: locationGroup.locations.length }
      )}
    />
  );
};

export default UserTooltip;
